<template>
  <PlatformDetailPage type="business" />
</template>

<script>
import PlatformDetailPage from '../components/reference/PlatformDetailPage'

export default {
  name: 'WorkbenchPage',
  components: { PlatformDetailPage }
}
</script>
